import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { getDefaultWidgets, widgetTypeKeys, WIDGET_LIST, WIDGET_TYPES } from '.';
import { getFeature } from '@src/globalStore/featureStore';
import featureNames from '@src/utils/featureToggle/constants';
import { ECO_WIDGET_TYPES } from './eco';
import { EI_WIDGET_TYPES } from './ei';
import { checkIsInternalUser } from '@src/globalStore/profileStore';

const noWidgetTypes = () => ({});

export const getDefaultDashboardConfig = () => {
  return {
    name: `${CURRENT_PRODUCT_MODE}-widgets`,
    widgets: getDefaultWidgets(),
  };
};

const getWidgetTypesForEco = () => {
  const typeKeys = widgetTypeKeys as typeof ECO_WIDGET_TYPES;
  const filteredWidgetTypes = { ...WIDGET_TYPES };

  // deprecate rca: https://conviva.atlassian.net/browse/HP-14322
  delete filteredWidgetTypes[typeKeys.autoRca];

  // QoE and Impacted time
  const isAppSPIEnabled = getFeature(featureNames.APP_SPI);
  if (!isAppSPIEnabled) {
    delete filteredWidgetTypes[typeKeys.qoe];
    delete filteredWidgetTypes[typeKeys.impactedTime];
    delete filteredWidgetTypes[typeKeys.improvementOpportunities];
  }

  return filteredWidgetTypes;
};

const getWidgetTypesForVideo = () => {
  const typeKeys = widgetTypeKeys as typeof EI_WIDGET_TYPES;
  const filteredWidgetTypes = { ...WIDGET_TYPES };
  const isInternalUser = checkIsInternalUser();

  // filter based on features here
  if (!isInternalUser) {
    // delete filteredWidgetTypes[typeKeys.viewers];
  }

  return filteredWidgetTypes;
};

export const getSupportedWidgetTypes =
  {
    EI: getWidgetTypesForVideo,
    APP: getWidgetTypesForEco,
  }[CURRENT_PRODUCT_MODE] || noWidgetTypes;

export const getSupportedWidgets = () => {
  const widgetTypes = Object.values(getSupportedWidgetTypes());
  const filteredWidgets = WIDGET_LIST.filter((wc: any) => widgetTypes.includes(wc.type));
  return filteredWidgets;
};

// filter and clean widget state
// order does not need filtering as it gets handled by parsing logic during render
export const filterSupportedWidgets = (widgets) => {
  const widgetTypes = Object.values(getSupportedWidgetTypes());
  const filteredWidgets = {};
  Object.keys(widgets).forEach((wid: any) => {
    const wc = widgets[wid];
    if (widgetTypes.includes(wc.type)) {
      filteredWidgets[wid] = widgets[wid];
    }
  });
  return filteredWidgets;
};
